module.exports = __webpack_public_path__ + "img/MGH-Gaien-3.78d684c6.jpg";